import type { CaseDebtor } from '../../../../types/LegalCase';

// Devedores do caso na grid, no modal do credor e no Resumo (AF-3817). O nome é o nome no processo
// (adendo ao ADR 001); parte só com cadastro em Pessoas e sem nome vira o mesmo placeholder da
// lista de partes.
export const NAMELESS_DEBTOR_LABEL = 'Cadastrado em Pessoas';

export interface DebtorCell {
    label: string;
    tooltip: string;
}

const debtorLabel = (debtor: CaseDebtor): string => debtor.name || NAMELESS_DEBTOR_LABEL;

export const debtorCell = (debtors: CaseDebtor[] | undefined): DebtorCell => {
    if (!debtors || debtors.length === 0) return { label: '—', tooltip: '' };
    const labels = debtors.map(debtorLabel);
    const extra = labels.length - 1;
    return {
        label: extra > 0 ? `${labels[0]} +${extra}` : labels[0],
        tooltip: labels.join(', '),
    };
};

const normalize = (name: string): string => name.trim().replace(/\s+/g, ' ').toLocaleLowerCase('pt-BR');

// Nome no processo × nome cadastral: só "difere" quando os dois existem e não são o mesmo nome
// ignorando maiúsculas e espaços (decisão 4 do plano).
export const namesDiffer = (nameInCase: string | null, registeredName: string | null): boolean => {
    if (!nameInCase || !registeredName) return false;
    return normalize(nameInCase) !== normalize(registeredName);
};
